import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  imports: [MatButtonToggleModule],
  exports: [MatButtonToggleModule]
})
export class TiimeButtonToggleModule {}
